var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49996 48.6667C3.49996 51.4271 5.73954 53.6667 8.49996 53.6667H38.5C41.2604 53.6667 43.5 51.4271 43.5 48.6667V13.6667H3.49996V48.6667ZM31.8333 22C31.8333 21.0756 32.5755 20.3334 33.5 20.3334C34.4244 20.3334 35.1666 21.0756 35.1666 22V45.3334C35.1666 46.2579 34.4244 47 33.5 47C32.5755 47 31.8333 46.2579 31.8333 45.3334V22ZM21.8333 22C21.8333 21.0756 22.5755 20.3334 23.5 20.3334C24.4244 20.3334 25.1666 21.0756 25.1666 22V45.3334C25.1666 46.2579 24.4244 47 23.5 47C22.5755 47 21.8333 46.2579 21.8333 45.3334V22ZM11.8333 22C11.8333 21.0756 12.5755 20.3334 13.5 20.3334C14.4244 20.3334 15.1666 21.0756 15.1666 22V45.3334C15.1666 46.2579 14.4244 47 13.5 47C12.5755 47 11.8333 46.2579 11.8333 45.3334V22ZM45.1666 3.66671H33.5L32.2939 1.25462C32.0117 0.690041 31.4345 0.333374 30.8032 0.333374H16.1967C15.5654 0.333374 14.9884 0.690041 14.706 1.25462L13.5 3.66671H1.83329C0.912876 3.66671 0.166626 4.41275 0.166626 5.33337V8.66671C0.166626 9.58712 0.912876 10.3334 1.83329 10.3334H45.1666C46.0872 10.3334 46.8333 9.58712 46.8333 8.66671V5.33337C46.8333 4.41275 46.0872 3.66671 45.1666 3.66671Z",
    fill: "#FF3541"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d431e8965610d277f42cafd11092f509.svg";
export { ForwardRef as ReactComponent };